/**
 * Compatibility shim: backoffice owns the entire origin so BACKOFFICE_BASE is '/'.
 * Imported by copied admin pages that still reference the old module name.
 */
export const BACKOFFICE_BASE = '/';

export const backofficePath = (suffix: string) => {
  if (!suffix || suffix === '/') return '/';
  return suffix.startsWith('/') ? suffix : `/${suffix}`;
};

export const BACKOFFICE_LOGIN_PATH = '/login';
